import { API_AUTH } from "../../common";

const ConfigPhiKhacHangKyApi = {
  getList: (kieuPhiKhac) => API_AUTH.get(`api/configphikhachangky/${kieuPhiKhac}`),
  addOrUpdate: (data) => API_AUTH.post("api/configphikhachangky/addorupdate", data),
  changeStatus: (id) => API_AUTH.put(`api/configphikhachangky/changestatus/${id}`),
  delete: (id) => API_AUTH.delete(`api/configphikhachangky/${id}`),
};

export default ConfigPhiKhacHangKyApi;